import styled from 'styled-components';
import { getUrlWithToken } from '../../../utils/common';

export const Cover = styled.div`
  background-image: url(${({ src }) => getUrlWithToken(src)});
  background-size: cover;
  background-position: center center;
  height: 300px;
  width: 100%;
  margin-bottom: 32px;
`;

export const DocumentCardContainer = styled.div``;

export const DocumentCard = styled.div`
  background-color: #eff5fb;
  padding: 24px;
  display: flex;
  column-gap: 32px;
  margin-bottom: 32px;

  @media ${({ theme }) => theme.device.mobileL} {
    position: relative;
    margin-inline: -16px;
    padding: 16px;

    .statistics-heading {
      //to accomodate for FileImg
      margin-right: 30px;
    }
  }
`;

export const FileImg = styled.img`
  width: 24px;
  height: 24px;
  aspect-ratio: 1;
  display: block;

  @media ${({ theme }) => theme.device.mobileL} {
    position: absolute;
    right: 24px;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  width: 100%;

  @media ${({ theme }) => theme.device.mobileL} {
    row-gap: 20px;
  }
`;

export const CardFooter = styled.footer`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  column-gap: 16px;

  @media ${({ theme }) => theme.device.mobileL} {
    flex-direction: column;
  }
`;

export const CardDownload = styled.div`
  display: flex;
  align-items: baseline;
  column-gap: 16px;

  @media ${({ theme }) => theme.device.mobileL} {
    margin-left: auto;
  }
`;
